export interface Organization {
    id?: string;
    slug?: string;
    name: string;
}

export function createOrganization(): Organization {
    return {
        id: undefined,
        slug: undefined,
        name: ''
    };
}